var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"body-2 font-weight-bold mb-1"},[_vm._v(_vm._s(_vm.label))]),_c('v-card',{staticClass:"pa-2",class:{'grey lighten-3': !_vm.$root.dark},attrs:{"flat":"","outlined":"","min-height":_vm.minHeight}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }